import React from "react";
import "./footer.css"


export default function Footer() {
    return (
       
            <div  class="elementor elementor-6 elementor-motion-effects-parent">
            <section id="section1" class="elementor-section elementor-top-section elementor-element elementor-element-10e1dba elementor-section-boxed elementor-section-height-default elementor-section-height-default"  data-element_type="section">
                <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d53dc36" data-element_type="column" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
                        <div class="elementor-widget-wrap elementor-element-populated" style={{ background: "linear-gradient(260deg,#000000 0%,#3d608d 100%" }}>
                            <div class="elementor-background-overlay"></div>
                            <div class="elementor-element elementor-element-6e0b6ce elementor-widget elementor-widget-heading"  data-element_type="widget" data-widget_type="heading.default">
                                <div class="elementor-widget-container">
                                    <h2 class="elementor-heading-title elementor-size-default">
                                        Join the community
                                    </h2>
                                </div>
                            </div>
                            <div class="elementor-element elementor-element-3a7da0f elementor-widget elementor-widget-text-editor"  data-element_type="widget" data-widget_type="text-editor.default">
                                <div class="elementor-widget-container">
                                    We are so humbled to have your early support.
                                </div>
                            </div>
                           
                            <div class="elementor-element elementor-element-e5ef24b elementor-widget__width-auto elementor-mobile-align-center elementor-widget-mobile__width-inherit elementor-widget elementor-widget-button" data-element_type="widget" data-widget_type="button.default">
                                <div class="elementor-widget-container" >
                                    <div class="elementor-button-wrapper" >
                                        <a href="/mint" class="elementor-button-link elementor-button elementor-size-md elementor-animation-grow" role="button">
                                            <span class="elementor-button-content-wrapper" >
                                                
                                                <span class="elementor-button-text">Mint Free NFT's</span>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div styl={{marginBottom:"20px"}} class="elementor-element elementor-element-e5ef24b elementor-widget__width-auto elementor-mobile-align-center elementor-widget-mobile__width-inherit elementor-widget elementor-widget-button" data-element_type="widget" data-widget_type="button.default">
                                <div class="elementor-widget-container">
                                    <div class="elementor-button-wrapper">
                                        <a href="https://discord.gg/wMcv6HW6VJ" target="_blank" class="elementor-button-link elementor-button elementor-size-md elementor-animation-grow" role="button">
                                            <span class="elementor-button-content-wrapper">
                                                <span class="elementor-button-icon elementor-align-icon-right">
                                                    <i aria-hidden="true" class="fab fa-discord"></i>
                                                </span>
                                                <span class="elementor-button-text">Join Discord</span>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="elementor-element elementor-element-e5ef24b elementor-widget__width-auto elementor-mobile-align-center elementor-widget-mobile__width-inherit elementor-widget elementor-widget-button" data-element_type="widget" data-widget_type="button.default">
                                <div class="elementor-widget-container" >
                                    <div class="elementor-button-wrapper" >
                                        <a href="https://telegram.me/+OqiC3gNJDQ1hY2Rl" target="_blank" class="elementor-button-link elementor-button elementor-size-md elementor-animation-grow" role="button">
                                            <span class="elementor-button-content-wrapper" >
                                                <span class="elementor-button-icon elementor-align-icon-right">
                                                    <i aria-hidden="true" class="fab fa-telegram"></i>
                                                </span>
                                                <span class="elementor-button-text">Join Telegram</span>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            
                        </div>
                    </div>
                </div>
            </section>


                </div>
           

    );
}
